module.exports = __webpack_public_path__ + "assets/sy.64f0d2d7.svg";